export default "__VITE_ASSET__a5e1b2a2__"